// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lz-1";
export var messageSideRight = "_lz-2";
export var subscribeToBackInStockBubbleContainer = "_lz-0";